// Which chart views a controls strip offers, and which of them it opens on. Every question type
// declares its own list; these two rules are the same whichever list they are applied to.

import { DEFAULT_CHART_VIEW } from '@aytm/app/stats/page/question-views/components/lib/constants'

// The list opens on the shared default where it offers one, and on its own first view otherwise.
export const getDefaultChartView = (chartViews = [], defaultChartView = DEFAULT_CHART_VIEW) => {
  const isDefaultMissing = chartViews.length && !chartViews.some(v => v.value === defaultChartView)

  return isDefaultMissing ? chartViews[0].value : defaultChartView
}

// A question may narrow the views it offers; saying nothing leaves the type's own list alone.
export const resolveAvailableViewModesByFormat = (viewModes = [], format) => {
  if (!format?.viewModes?.length) {
    return viewModes
  }

  return viewModes.filter(v => format.viewModes.includes(v.value))
}
